import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-hints',
  templateUrl: './hints.component.html',
  styleUrls: ['./hints.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HintsComponent {
  @Input() public hintImage: string = 'type1';
  @Input() public hintText!: string;
  @Input() public position: 'top' | 'bottom' = 'top';
  constructor() {}
}
